import type { ReactNode } from "react"
import { createContext, useContext, useState } from "react"

interface AuthModalContextType {
  isOpen: boolean
  defaultTab: "login" | "register"
  openModal: (tab?: "login" | "register") => void
  closeModal: () => void
}

const AuthModalContext = createContext<AuthModalContextType | null>(null)

export function AuthModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [defaultTab, setDefaultTab] = useState<"login" | "register">("login")

  const openModal = (tab: "login" | "register" = "login") => {
    setDefaultTab(tab)
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <AuthModalContext.Provider
      value={{ isOpen, defaultTab, openModal, closeModal }}
    >
      {children}
    </AuthModalContext.Provider>
  )
}

export function useAuthModal() {
  const context = useContext(AuthModalContext)
  if (!context) {
    throw new Error("useAuthModal must be used within an AuthModalProvider")
  }
  return context
}
